import { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';
import * as PROFILE from "../../../../../constants/profile"

// props:
// - visible
// - profile
// - onHide
// - onProfileSaved
function ProfileEditDialog(props) {  
  const [isNew, setIsNew] = useState(false);
  const [pages, setPages] = useState([]);
  const defaultValues = {
    description: ''
  };
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset
  } = useForm({ defaultValues });
  
  // #region methods

  const resetForm = () => {
    reset(defaultValues);
    setPages([]);
  }

  const createProfile = (
    description,
    pages) => {
    fetch(`${process.env.REACT_APP_API_URL}/profile/create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        description,
        pages
      }),
    }).then(response => response.json()).then(data => {
      if (data.responseCode === 'OK') {
        console.log("ProfileEditDialog: createProfile: success");
        props.onProfileSaved();
        reset();
      } else {
        console.log("ProfileEditDialog: createProfile: error");
      }
    });
  };

  const updateProfile = (
    profileId,
    description,
    pages) => {
    fetch(`${process.env.REACT_APP_API_URL}/profile/update`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        profileId,
        description,
        pages
      }),
    }).then(response => response.json()).then(data => {
      if (data.responseCode === 'OK') {
        console.log("ProfileEditDialog: updateProfile: success");
        props.onProfileSaved();
        reset();
      } else {
        console.log("ProfileEditDialog: updateProfile: error");
      }
    });
  };

  const getFormErrorMessage = (name) => {
    return errors[name] && (
      <small className="p-error">
        {errors[name].message}
      </small>
    )
  };

  // #endregion

  // #region events

  const onPagesChange = (e) => {
    let _pages = [...pages];
    if (e.checked)
      _pages.push(e.value);
    else
      _pages.splice(_pages.indexOf(e.value), 1);
    setPages(_pages);    
  };

  const onDialogHide = () => {
    if (props.onHide) props.onHide();
  };
  
  const onFormSubmit = (data) => {
    let _pages = [];
    pages.forEach(str => {
      _pages.push(Number(str));
    });
    if (isNew) {
      createProfile(data.description, _pages);
    } else {
      updateProfile(props.profile.profileId, data.description, _pages);
    }
    
  };

  // #endregion

  // #region templates

  const formTemplate = (
    <>
      <form
        onSubmit={handleSubmit(onFormSubmit)}
        className="p-fluid">
        <div className='pt-5'>
          <span className="p-float-label">
            <Controller
              name="description"
              control={control}
              rules={{ required: 'La descripción es requerida.' }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.description}
                  {...field}
                  autoFocus
                  className={classNames({ 'p-invalid': fieldState.invalid })} />
            )} />
            <label
              htmlFor="description"
              className={classNames({ 'p-error': errors.description })}>
              Descripción*
            </label>
          </span>
          {getFormErrorMessage('description')}
        </div>        
        <div className='pt-5'>

          <span className="p-float-label">           
            <input className='p-filled' style={{ display: 'none' }}></input>
            <label
              htmlFor="description">
              Permisos
            </label>
          </span>
          <div className="field-checkbox">
            <Checkbox
              inputId={`pageCheckbox${PROFILE.PERMISSIONS.METRICS_REPORT}`}
              name="page"
              value={PROFILE.PERMISSIONS.METRICS_REPORT.toString()}
              onChange={onPagesChange}
              checked={pages.indexOf(PROFILE.PERMISSIONS.METRICS_REPORT.toString()) !== -1} />
            <label htmlFor={`pageCheckbox${PROFILE.PERMISSIONS.METRICS_REPORT}`}>
              &nbsp;Reporte de Métricas
            </label>
          </div>
          <div className="field-checkbox">
            <Checkbox
              inputId={`pageCheckbox${PROFILE.PERMISSIONS.SERVICES_REPORT}`}
              name="page" 
              value={PROFILE.PERMISSIONS.SERVICES_REPORT.toString()}
              onChange={onPagesChange} 
              checked={pages.indexOf(PROFILE.PERMISSIONS.SERVICES_REPORT.toString()) !== -1} />
            <label htmlFor={`pageCheckbox${PROFILE.PERMISSIONS.SERVICES_REPORT}`}>
              &nbsp;Reporte de Servicios
            </label>
          </div>
          <div className="field-checkbox">
            <Checkbox
              inputId={`pageCheckbox${PROFILE.PERMISSIONS.WEEKLY_PRODUCTION_REPORT}`}
              name="page"
              value={PROFILE.PERMISSIONS.WEEKLY_PRODUCTION_REPORT.toString()}
              onChange={onPagesChange}
              checked={pages.indexOf(PROFILE.PERMISSIONS.WEEKLY_PRODUCTION_REPORT.toString()) !== -1} />
            <label htmlFor={`pageCheckbox${PROFILE.PERMISSIONS.WEEKLY_PRODUCTION_REPORT}`}>
              &nbsp;Reporte de Producción semanal
            </label>
          </div>    
          <div className="field-checkbox">
            <Checkbox
              inputId={`pageCheckbox${PROFILE.PERMISSIONS.DRIVER_REPORT}`}
              name="page"
              value={PROFILE.PERMISSIONS.DRIVER_REPORT.toString()}
              onChange={onPagesChange}
              checked={pages.indexOf(PROFILE.PERMISSIONS.DRIVER_REPORT.toString()) !== -1} />
            <label htmlFor={`pageCheckbox${PROFILE.PERMISSIONS.DRIVER_REPORT}`}>
              &nbsp;Reporte Historial
            </label>
          </div>
          <div className="field-checkbox">
            <Checkbox
              inputId={`pageCheckbox${PROFILE.PERMISSIONS.DRIVER_PAYMENT_REPORT}`}
              name="page"
              value={PROFILE.PERMISSIONS.DRIVER_PAYMENT_REPORT.toString()}
              onChange={onPagesChange}
              checked={pages.indexOf(PROFILE.PERMISSIONS.DRIVER_PAYMENT_REPORT.toString()) !== -1} />
            <label htmlFor={`pageCheckbox${PROFILE.PERMISSIONS.DRIVER_PAYMENT_REPORT}`}>
              &nbsp;Reporte por Operador
            </label>
          </div>
          <div className="field-checkbox">
            <Checkbox
              inputId={`pageCheckbox${PROFILE.PERMISSIONS.INCOME_REEPORT}`}
              name="page"
              value={PROFILE.PERMISSIONS.INCOME_REEPORT.toString()}
              onChange={onPagesChange}
              checked={pages.indexOf(PROFILE.PERMISSIONS.INCOME_REEPORT.toString()) !== -1} />
            <label htmlFor={`pageCheckbox${PROFILE.PERMISSIONS.INCOME_REEPORT}`}>
              &nbsp;Reporte de Ingresos
            </label>
          </div>
          <div className="field-checkbox">
            <Checkbox
              inputId={`pageCheckbox${PROFILE.PERMISSIONS.PAYMENT_ORDER_REPORT}`}
              name="page"
              value={PROFILE.PERMISSIONS.PAYMENT_ORDER_REPORT.toString()}
              onChange={onPagesChange}
              checked={pages.indexOf(PROFILE.PERMISSIONS.PAYMENT_ORDER_REPORT.toString()) !== -1} />
            <label htmlFor={`pageCheckbox${PROFILE.PERMISSIONS.PAYMENT_ORDER_REPORT}`}>
              &nbsp;Reporte de Caja
            </label>
          </div>          
          <div className="field-checkbox">
            <Checkbox
              inputId={`pageCheckbox${PROFILE.PERMISSIONS.ROUTES_REPORT}`}
              name="page"
              value={PROFILE.PERMISSIONS.ROUTES_REPORT.toString()}
              onChange={onPagesChange}
              checked={pages.indexOf(PROFILE.PERMISSIONS.ROUTES_REPORT.toString()) !== -1} />
            <label htmlFor={`pageCheckbox${PROFILE.PERMISSIONS.ROUTES_REPORT}`}>
              &nbsp;Reporte de Rutas
            </label>
          </div>
          <div className="field-checkbox">
            <Checkbox
              inputId={`pageCheckbox${PROFILE.PERMISSIONS.ROUTES_REPORT_BY_STATUS}`}
              name="page"
              value={PROFILE.PERMISSIONS.ROUTES_REPORT_BY_STATUS.toString()}
              onChange={onPagesChange}
              checked={pages.indexOf(PROFILE.PERMISSIONS.ROUTES_REPORT_BY_STATUS.toString()) !== -1} />
            <label htmlFor={`pageCheckbox${PROFILE.PERMISSIONS.ROUTES_REPORT_BY_STATUS}`}>
              &nbsp;Reporte de Rutas por Estatus
            </label>
          </div>  
          <div className="field-checkbox">
            <Checkbox
              inputId={`pageCheckbox${PROFILE.PERMISSIONS.DOWNLOAD_REPORTS}`}
              name="page" 
              value={PROFILE.PERMISSIONS.DOWNLOAD_REPORTS.toString()}
              onChange={onPagesChange} 
              checked={pages.indexOf(PROFILE.PERMISSIONS.DOWNLOAD_REPORTS.toString()) !== -1} />
            <label htmlFor={`pageCheckbox${PROFILE.PERMISSIONS.DOWNLOAD_REPORTS}`}>
              &nbsp;Descargar reportes
            </label>
          </div>
          <div className="field-checkbox">
            <Checkbox 
              inputId={`pageCheckbox${PROFILE.PERMISSIONS.UPLOAD_SALE}`}
              name="page" 
              value={PROFILE.PERMISSIONS.UPLOAD_SALE.toString()}
              onChange={onPagesChange} 
              checked={pages.indexOf(PROFILE.PERMISSIONS.UPLOAD_SALE.toString()) !== -1} />
            <label htmlFor={`pageCheckbox${PROFILE.PERMISSIONS.UPLOAD_SALE}`}>
              &nbsp;Subir venta
            </label>
          </div>
          <div className="field-checkbox">
            <Checkbox 
              inputId={`pageCheckbox${PROFILE.PERMISSIONS.ASSIGNMENT}`}
              name="page" 
              value={PROFILE.PERMISSIONS.ASSIGNMENT.toString()}
              onChange={onPagesChange} 
              checked={pages.indexOf(PROFILE.PERMISSIONS.ASSIGNMENT.toString()) !== -1} />
            <label htmlFor={`pageCheckbox${PROFILE.PERMISSIONS.ASSIGNMENT}`}>
              &nbsp;Asignación
            </label>
          </div>
          <div className="field-checkbox">
            <Checkbox
              inputId={`pageCheckbox${PROFILE.PERMISSIONS.ASSIGNMENT_BY_DRIVER}`}
              name="page"
              value={PROFILE.PERMISSIONS.ASSIGNMENT_BY_DRIVER.toString()}
              onChange={onPagesChange}
              checked={pages.indexOf(PROFILE.PERMISSIONS.ASSIGNMENT_BY_DRIVER.toString()) !== -1} />
            <label htmlFor={`pageCheckbox${PROFILE.PERMISSIONS.ASSIGNMENT_BY_DRIVER}`}>
              &nbsp;Asignación por Conductor
            </label>
          </div>
          <div className="field-checkbox">
            <Checkbox 
              inputId={`pageCheckbox${PROFILE.PERMISSIONS.CATALOGS}`}
              name="page" 
              value={PROFILE.PERMISSIONS.CATALOGS.toString()}
              onChange={onPagesChange} 
              checked={pages.indexOf(PROFILE.PERMISSIONS.CATALOGS.toString()) !== -1} />
            <label htmlFor={`pageCheckbox${PROFILE.PERMISSIONS.CATALOGS}`}>
              &nbsp;Catálogos
            </label>
          </div>
          <div className="field-checkbox">
            <Checkbox
              inputId={`pageCheckbox${PROFILE.PERMISSIONS.MAINTENANCE_LOG_REPORT}`}
              name="page"
              value={PROFILE.PERMISSIONS.MAINTENANCE_LOG_REPORT.toString()}
              onChange={onPagesChange}
              checked={pages.indexOf(PROFILE.PERMISSIONS.MAINTENANCE_LOG_REPORT.toString()) !== -1} />
            <label htmlFor={`pageCheckbox${PROFILE.PERMISSIONS.MAINTENANCE_LOG_REPORT}`}>
              &nbsp;Reporte de Bitácora de Mantenimientos
            </label>
          </div>
          <div className="field-checkbox">
            <Checkbox
              inputId={`pageCheckbox${PROFILE.PERMISSIONS.ADD_EDIT_MAINTENANCE_LOG}`}
              name="page"
              value={PROFILE.PERMISSIONS.ADD_EDIT_MAINTENANCE_LOG.toString()}
              onChange={onPagesChange}
              checked={pages.indexOf(PROFILE.PERMISSIONS.ADD_EDIT_MAINTENANCE_LOG.toString()) !== -1} />
            <label htmlFor={`pageCheckbox${PROFILE.PERMISSIONS.ADD_EDIT_MAINTENANCE_LOG}`}>
              &nbsp;Añadir o editar Bitácora de Mantenimiento
            </label>
          </div>
          <div className="field-checkbox">
            <Checkbox
              inputId={`pageCheckbox${PROFILE.PERMISSIONS.MAINTENANCE_CATALOGS}`}
              name="page"
              value={PROFILE.PERMISSIONS.MAINTENANCE_CATALOGS.toString()}
              onChange={onPagesChange}
              checked={pages.indexOf(PROFILE.PERMISSIONS.MAINTENANCE_CATALOGS.toString()) !== -1} />
            <label htmlFor={`pageCheckbox${PROFILE.PERMISSIONS.MAINTENANCE_CATALOGS}`}>
              &nbsp;Catálogos de Mantenimientos
            </label>
          </div>          
        </div>
        <Button
          type="submit"
          label="Guardar"
          className="p-button-raised p-button-sm mt-4" />
      </form>
    </>
  );

  const dialogTemplate = (
    <>
      <Dialog
        header=""
        visible={props.visible}
        onHide={onDialogHide}
        breakpoints={{ '960px': '75vw' }}
        style={{ width: '50vw' }}>
        <h1>Perfíl</h1>
        {formTemplate}
      </Dialog>      
    </>
  );

  // #endregion

  useEffect(() => {
    resetForm();
    setIsNew(props.profile === null);
    if (props.profile) {
      setIsNew(false);
      reset(props.profile);
      let _pages = [];
      props.profile.pages.forEach(page => {
        _pages.push(page.toString());
      });
      setPages(_pages);
    } else {      
      setIsNew(true);
    }    
  }, [props.visible, props.profile]);

  return (
    <>
      <article>
        {dialogTemplate}
      </article>
    </>
  );
}

export default ProfileEditDialog;
